module.exports = __webpack_public_path__ + "img/france-colorectal-cancer-female.e6cdd434.png";